export const criticalFilterOptions = [
  { value: "Nem kritikus", label: "critical-filter-option-false" },
  { value: "Kritikus", label: "critical-filter-option-true" },
];
